import React, { Fragment, FunctionComponent } from "react";
import { BLOCK_TYPE } from "app/blocks/block.types";
import Entrances from "blocks/components/Entrances/Entrances";

const HomePageBlock: FunctionComponent<BLOCK_TYPE> = (props) => {
    const renderControl = (props: BLOCK_TYPE): React.ReactElement | null => {
        const { settings, contentUdi, settingsUdi, ...content } = props as any;
        switch (content?._contentType) {
            case "blockEntrances": {
                return (
                    <Entrances
                        content={content}
                        settings={settings}
                    />
                );
            }
            default: {
                return null;
            }
        }
    };

    return <Fragment>{renderControl(props)}</Fragment>;
};

export default HomePageBlock;
